// c_brand-display-name.js — 外部アプリ（レコメンド等）がテーマ外で描画したブランド名を、表示用表記へ置き換える。
// テーマ内の表示は c_brand-display-name.liquid / c_zeta.js で置き換え済み。ここではそれ以外の後から差し込まれた要素を対象にする。
// 誤置換を防ぐため、テキストノードの中身（前後の空白を除く）がブランド名と完全一致する場合だけ置き換える。
// 表記の対応表は c_zeta.js の BRAND_DISPLAY_NAMES（window.Zeta.displayBrandName）を使う。

(function () {
  'use strict';

  const SKIP_TAGS = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT', 'SELECT', 'OPTION', 'TEMPLATE']);

  const toDisplay = (name) =>
    window.Zeta && typeof window.Zeta.displayBrandName === 'function' ? window.Zeta.displayBrandName(name) : name;

  const replaceTextNode = (node) => {
    const parent = node.parentNode;
    if (!parent || SKIP_TAGS.has(parent.nodeName) || parent.isContentEditable) return;
    const raw = node.nodeValue;
    if (!raw) return;
    const trimmed = raw.trim();
    // ブランド名より長い文章などは対象外（短いラベルのみ）
    if (!trimmed || trimmed.length > 60) return;
    const display = toDisplay(trimmed);
    if (display === trimmed) return;
    node.nodeValue = raw.replace(trimmed, display);
  };

  const walk = (root) => {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) {
      replaceTextNode(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;
    if (root.nodeType === Node.ELEMENT_NODE && SKIP_TAGS.has(root.nodeName)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();
    while (node) {
      replaceTextNode(node);
      node = walker.nextNode();
    }
  };

  const start = () => {
    walk(document.body);
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        if (m.type === 'characterData') {
          replaceTextNode(m.target);
        } else {
          m.addedNodes.forEach(walk);
        }
      });
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
